import { render, staticRenderFns } from "./otherExpenses.vue?vue&type=template&id=437a4174&scoped=true&"
import script from "./otherExpenses.vue?vue&type=script&lang=js&"
export * from "./otherExpenses.vue?vue&type=script&lang=js&"
import style0 from "./otherExpenses.vue?vue&type=style&index=0&id=437a4174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437a4174",
  null
  
)

export default component.exports